<template>
    <div class="page-scan-in-list">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">快遞記錄</div>
            <div class="breadcrumb-item">珠海倉記錄 自提點件數</div>
        </div>
        <div class="card-block">
            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <DatePicker class="no-suffix" type="date" size="small" :clearable="true" placeholder="自提點件數起始日期" v-model="form.start_time" value-format="yyyy-MM-dd" :editable="false" style='width: 100%;'></DatePicker>
                </FormItem>

                <FormItem>
                    <DatePicker class="no-suffix" type="date" size="small" :clearable="true" placeholder="自提點件數結束日期" v-model="form.end_time" value-format="yyyy-MM-dd" :editable="false" style='width: 100%;'></DatePicker>
                </FormItem>

                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleSearch">搜索</div>
                    </div>
                </FormItem>

                <FormItem>
                    <div slot="label" class="form-label">
                        <Icon type="ios-square" color="#E0FFD1" style="width:20px;height:20px;"/>
                        <span>出庫=上架</span>
                    </div>
                </FormItem>

                <FormItem>
                    <div slot="label" class="form-label">
                        <Icon type="ios-square" color="#FFD8D8" style="width:20px;height:20px;"/>
                        <span>出庫>上架</span>
                    </div>
                </FormItem>
                
                <FormItem>
                    <div slot="label" class="form-label">
                        <Icon type="ios-square" color="#FFEFCC" style="width:20px;height:20px;"/>
                        <span>出庫<上架</span>
                    </div>
                </FormItem>
            </Form>

            <!-- <div class="card-block pd-bt"> -->
                <Row type="flex"  align="top" class="code-row-bg">
                    <Col span="4" class="pagger-left" v-for="(item, index) in pickAdmin">
                        <div  style="border: 1px solid;">
                        <div class="pagger-total" style="margin-left: 15px;margin-top: 10px;font-size: 36px;">{{item.realname|ellipsis}}</div>
                        <br>
                        <div class="pagger-total" style="margin-left: 15px;">{{item.realname}}</div>
                        <br>
                        <div class="pagger-total" style="padding: 10px;background-color:#E0FFD1" align="center">入庫件數 {{item.parent_id}}</div>
                        <div class="pagger-total" style="padding: 10px;background-color:#E0FFD1" align="center">出庫件數 {{item.parent_id}}</div>
                        </div>
                    </Col>
                </Row>
            <!-- </div> -->
        </div>
    </div>
</template>

<script>
    import Store from '../../../assets/js/store.js'
    export default {
        data()
        {
            return {
                pickAdmin: [],
                pageIndex: 1,
                curPageSize: 10,
                totalCount: 1,

                isLoading: true,

                form: {
                    odd_numbers: '',
                    username: '',
                    phone: '',
                    shelves: '',
                    arrive: '',
                    status: '',
                    start_time: '',
                    end_time: '',
                },
                table: {
                    column: [
                        {
                            title: '日期',
                            key: 'stroeName',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '入倉件數',
                            key: 'odd_numbers',
                            slot: 'odd_numbers',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '出倉件數',
                            key: 'phone',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '門店件數',
                            key: 'phone',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '智能櫃件數',
                            key: 'phone',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '宅配件數',
                            key: 'phone',
                            sortable: true,
                            align: 'center',
                            minWidth: 70
                        },
                        {
                            title: '操作',
                            sortable: true,
                            slot: 'action',
                            align: 'center',
                            minWidth: 130
                        },
                    ],
                    data: []
                },
                table1: {
                    column: [
                        {
                            title: '快遞單號',
                            key: 'order',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '客戶電話',
                            key: 'phone',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '客戶名稱',
                            key: 'username',
                            align: 'center',
                            minWidth: 80
                        },
                    ],
                    column1: [
                        {
                            title: '重量',
                            key: 'weight',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '尺寸',
                            key: 'size_sum',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '提貨櫃點',
                            key: 'store',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column2: [
                        {
                            title: '快件明細',
                            key: 'detailed',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '異常件',
                            key: 'abnormal',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '出庫袋號',
                            key: 'sack_number',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column3: [
                        {
                            title: '最新貨態',
                            slot: 'status',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '更新時間',
                            key: 'created_time',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '貨架號',
                            key: 'shelves',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column4: [
                        {
                            title: '代收費',
                            key: 'amount',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '附加費',
                            key: 'surcharge_price',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '到附運費',
                            key: 'freight_collect',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column5: [
                        {
                            title: '超期費',
                            key: 'outTime_price',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '合計費用',
                            key: 'total_price',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    data: [],
                    data1: [],
                    data2: [],
                    data3: [],
                    data4: [],
                    data5: [],
                },
            };
        },
        created() {
            this.getPickAdmin();
        },
        filters: {
            ellipsis (value) {
              if (!value) return ''
              if (value.length > 6) {
                return value.slice(0,6) + '...'
              }
              return value
            }
          },
        methods: {
            getPickAdmin()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAdmin,
                    method: 'post'
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.pickAdmin = res.data.data;
                    }
                });
            },
            getList()
            {
                let form = this.form;

                this.isLoading = true;
                this.$Rq.requestAuth({
                    url: this.$Api.overtimelist,
                    method: 'get',
                    data: {
                        phone: form.phone,
                        storeId: form.arrive,
                        status: form.status,
                        orderNumber: form.odd_numbers,
                        start_time: form.start_time,
                        end_time: form.end_time,
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                    }
                }).then((res) =>
                {
                    this.isLoading = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        if(resData == undefined)
                        {
                            this.totalCount = 0;
                            this.table.data = tempArr;
                        }
                        else
                        {

                            for (let i = 0; i < resData.length; i++)
                            {
                                tempArr.push({
                                    arriveCode: resData[i].arriveCode,
                                    arrive_time: resData[i].arrive_time,
                                    cainiao_match: resData[i].cainiao_match,
                                    odd_numbers: resData[i].orderNumber,
                                    orderStats: resData[i].orderStats,
                                    outDay: resData[i].outDay + '天',
                                    phone: resData[i].phone,
                                    status: resData[i].status,
                                    stroeName: resData[i].stroeName,
                                });
                            }

                            this.totalCount = res.data.count;
                            this.table.data = tempArr;
                        }
                    }
                }).catch(() =>
                {
                    this.isLoading = false;
                });
            },

            handleSearch()
            {
                this.pageIndex = 1;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'zhuhaiInventoryGrid.scss';
</style>